import timezones from 'timezones-list';
import extraTimezones from './extraTimezones.json';
export const TIMEZONES = [...timezones, ...extraTimezones];
export const TIMEZONE_OPTIONS = TIMEZONES.map(tz => ({
  label: tz.label,
  value: tz.tzCode
}));
export const HOURS_OF_OPERATION_OPTIONS = [{
  name: 'hours',
  value: '24hours',
  label: '24 hrs / day'
}, {
  name: 'hours',
  value: 'custom',
  label: 'Custom hours'
}];
export const DAYS_OF_OPERATION_OPTIONS = [{
  name: 'days',
  value: '7days',
  label: '7 days / week'
}, {
  name: 'days',
  value: 'custom',
  label: 'Custom days'
}];